export default __webpack_public_path__ + "static/media/truck-group-tier-green-icon.a0f05112.svg";